import { useRef } from 'react';

export function useAbortController() {
    const abortController = useRef<null | AbortController>(null);

    return () => {
        // Cancel any in-flight requests
        if (abortController.current) {
            abortController.current.abort();
        }
        abortController.current = new AbortController();

        return abortController.current as AbortController;
    };
}
